import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faCheck, faFileLines, faListUl, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'underscore';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { ConfirmationDialogComponent } from '../../../../../../partials/content/widgets/general/confirmation-dialog/confirmation-dialog.component';
import { ActionTypeForInvetory } from '../../../../../../shared/enum';
import { TransactionService } from '../../../../../core/services/TransactionService';
import { InventoryService } from '../../../../pick-plan/services/inventory.service';
import { HandlingUnitDetailDTO } from '../../../models/handling-unit-detail';
import { HandlingUnitMasterDTO, handlingUnitLocation } from '../../../models/handling-unit-master';
import { InventoryAddItemPopupComponent } from '../../inventory-items/inventory-add-item-popup/inventory-add-item-popup.component';

export interface InventoryAdjustQtyData {
  Hum: HandlingUnitMasterDTO;
}

@Component({
  selector: 'inventory-adjust-qty-popup',
  templateUrl: './inventory-adjust-qty-popup.component.html',
  styleUrls: ['./inventory-adjust-qty-popup.component.scss']
})
export class InventoryAdjustQtyPopupComponent implements OnInit {

  @Input() isHumEdit: boolean = false;
  @Input() hum: HandlingUnitMasterDTO;
  @Output() valueChange = new EventEmitter<any>();

  static open(dialog: MatDialog, data: InventoryAdjustQtyData): MatDialogRef<InventoryAdjustQtyPopupComponent, HandlingUnitMasterDTO> {
    return dialog.open(InventoryAdjustQtyPopupComponent, { data, width: '860px', maxWidth: '95vw' });
  }

  private destroyRef = inject(DestroyRef);
  public transactionReasons = [];
  public reasonCodeId: number;
  private originalQuantities = new Map<number, number>();

  public isLoading: boolean = true;
  public faXmark = faXmark;
  public faTrash = faTrash;
  public faListUl = faListUl;
  public faPlus = faPlus;
  public faFileLines = faFileLines;
  public faCheck = faCheck;

  // Inline in Create Inventory these resolve to that dialog's ref and data; neither is used there.
  constructor(public dialogRef: MatDialogRef<InventoryAdjustQtyPopupComponent, HandlingUnitMasterDTO>,
    @Inject(MAT_DIALOG_DATA) public data: InventoryAdjustQtyData,
    private errorService: ErrorService,
    private dialog: MatDialog,
    private changeDetRef: ChangeDetectorRef,
    public transactionService: TransactionService,
    private router: Router,
    private inventoryService: InventoryService) { }

  ngOnInit() {
    // Own object inline, so Create Inventory's dialog data isn't overwritten.
    if (this.hum)
      this.data = { Hum: this.hum };

    // Store original quantities for comparison
    if (this.data.Hum && this.data.Hum.handlingUnitDetails) {
      this.data.Hum.handlingUnitDetails.forEach(hud => {
        this.originalQuantities.set(hud.id, hud.quantity);
      });
    }

    this.transactionService.getTransactionReasonCodes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      data = _.sortBy(data, 'reason');
      this.transactionReasons = data;
      this.isLoading = false;
      this.changeDetRef.detectChanges();
    }, err => {this.errorService.handleError(err); this.isLoading = false; this.changeDetRef.detectChanges();});


  }

  submit() {
    this.isLoading = true;
    this.data.Hum.transactionReasonCodeId = this.reasonCodeId;

    // Activate HUM and all HUDs when user submits adjustment (any interaction should reactivate inventory)
    this.data.Hum.isActive = true;
    if (this.data.Hum.handlingUnitDetails) {
      this.data.Hum.handlingUnitDetails.forEach(hud => {
        hud.isActive = true;
      });
    }

    //set flag if erp api call from UI
    let isERPSave = true;
    //Passing action type based on that call different erp api
    let actionType = ActionTypeForInvetory.AdjustQuantity;
    this.inventoryService.putInventoryHUM(this.data.Hum,isERPSave,actionType).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
      this.data.Hum.transactionReasonCodeId = undefined;
      this.dialogRef.close(this.data.Hum);
    }, error:err => {
      this.errorService.handleError(err);
      this.isLoading = false;
      this.changeDetRef.detectChanges();
    }});
  }

  close() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteItem(row) {
    let v = [];
    const confRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: '10%',
      data: {
        confirmLabel: 'Yes',
        title: 'Delete item?',
        confirmMessage: 'Are you sure you want to delete this item?',
        cancelLabel: 'No'
      }
    }).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if (result === true && !this.isHumEdit) {
        this.isLoading = true;
        this.data.Hum.handlingUnitDetails.forEach((element, index) => {
          if (element.id == row.id) {
            element.isActive = false;
            var t = [];
            this.changeDetRef.detectChanges();
          }
        });
        this.inventoryService.putInventoryHUM(this.data.Hum).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
          this.data.Hum.handlingUnitDetails.forEach((element, index) => {
            if (element.id == row.id) {
              this.data.Hum.handlingUnitDetails.splice(index, 1);
              this.changeDetRef.detectChanges();
            }
            this.isLoading = false;
          });
        }, error:err => {
          this.errorService.handleError(err);
          this.isLoading = false;
        }});
      }
      else if (result === true && this.isHumEdit) {
        this.hum.handlingUnitDetails.forEach((element, index) => {
          if (element == row) {
            this.hum.handlingUnitDetails.splice(index, 1);
          }
          this.isLoading = false;
        });

        this.changeDetRef.detectChanges();
        this.valueChange.emit(true);
      }
    });
  }

  addItem() {
    InventoryAddItemPopupComponent.open(this.dialog, { Hum: JSON.parse(JSON.stringify(this.data.Hum)) })
      .afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hum => {
        if (hum)
          this.data.Hum = hum;
      });
  }

  get unit(): HandlingUnitMasterDTO {
    return this.hum ?? this.data.Hum;
  }

  get subtitle(): string {
    return [this.data.Hum?.barcode, handlingUnitLocation(this.data.Hum)].filter(Boolean).join(' · ');
  }

  trackByIndex(index: number): number {
    return index;
  }

  getWeight(hud: HandlingUnitDetailDTO) {
    if(hud)
      return hud.quantity * hud.packageComponentQuantityPerPackage * hud.packageComponentWeight;
    else
      return 0;
  }
}
